import React, { ComponentProps } from 'react';
import { useTranslation } from 'react-i18next';
import { AppIconElement, AppIconList } from '../../../_lib/components/AppIconList';
import ContentMessage from '../../../_lib/components/ContentMessage/ContentMessage';
import { Namespace } from '../../../translation/namespace';
import { asView } from '../../../_lib/ViewFetcher';
import ScrollArea from '../../../components/atoms/ScrollArea/ScrollArea';

type AppLibraryPersonalDefaultViewProps = {
  mandatoryItems?: AppIconElement[];
  optionalItems?: AppIconElement[];
};

function AppLibraryPersonalDefault({ mandatoryItems = [], optionalItems = [] }: AppLibraryPersonalDefaultViewProps) {
  const { t } = useTranslation(Namespace.AppLibraryPersonal);

  const items = mandatoryItems?.concat(optionalItems);
  if (items.length === 0) {
    return <ContentMessage text={t('noPersonalItems')} />;
  }

  return (
    <ScrollArea to={100} bottomOffset={10}>
      <AppIconList modifier="pal" items={items} />
    </ScrollArea>
  );
}
export const AppLibraryPersonalDefaultView = asView(AppLibraryPersonalDefault);
export type AppLibraryPersonalDefaultView = ComponentProps<typeof AppLibraryPersonalDefaultView>;
